// ========================
// Events
// ========================
export const SHOWROOM_FETCH_EVENTS = 'showroomActions/FETCH_EVENTS';
export const SHOWROOM_FETCH_EVENTS_SUCCESS = 'showroomActions/FETCH_EVENTS_SUCCESS';
export const SHOWROOM_FETCH_EVENTS_FAILED = 'showroomActions/FETCH_EVENTS_FAILURE';

export const SHOWROOM_FETCH_EVENT_DETAIL = 'showroomActions/FETCH_EVENT_DETAIL';
export const SHOWROOM_FETCH_EVENT_DETAIL_SUCCESS = 'showroomActions/FETCH_EVENT_DETAIL_SUCCESS';
export const SHOWROOM_FETCH_EVENT_DETAIL_FAILED = 'showroomActions/FETCH_EVENT_DETAIL_FAILURE';

export const SHOWROOM_UPDATE_EVENT = 'showroomActions/UPDATE_EVENT';
export const SHOWROOM_UPDATE_EVENT_SUCCESS = 'showroomActions/UPDATE_EVENT_SUCCESS';
export const SHOWROOM_UPDATE_EVENT_FAILED = 'showroomActions/UPDATE_EVENT_FAILURE';

// ========================
// Host Applications (admin)
// ========================
export const SHOWROOM_FETCH_MEMBERS = 'showroomActions/FETCH_MEMBERS';
export const SHOWROOM_FETCH_MEMBERS_SUCCESS = 'showroomActions/FETCH_MEMBERS_SUCCESS';
export const SHOWROOM_FETCH_MEMBERS_FAILED = 'showroomActions/FETCH_MEMBERS_FAILURE';

// ========================
// Host Approval (admin)
// ========================
export const SHOWROOM_REVIEW_HOST = 'showroomActions/REVIEW_HOST';
export const SHOWROOM_REVIEW_HOST_SUCCESS = 'showroomActions/REVIEW_HOST_SUCCESS';
export const SHOWROOM_REVIEW_HOST_FAILED = 'showroomActions/REVIEW_HOST_FAILURE';

// ========================
// Viewers
// ========================
export const SHOWROOM_FETCH_VIEWERS = 'showroomActions/FETCH_VIEWERS';
export const SHOWROOM_FETCH_VIEWERS_SUCCESS = 'showroomActions/FETCH_VIEWERS_SUCCESS';
export const SHOWROOM_FETCH_VIEWERS_FAILED = 'showroomActions/FETCH_VIEWERS_FAILURE';

// ========================
// Access Requests (host)
// ========================
export const SHOWROOM_FETCH_ACCESS_REQUESTS =
  'showroomActions/FETCH_ACCESS_REQUESTS';
export const SHOWROOM_FETCH_ACCESS_REQUESTS_SUCCESS =
  'showroomActions/FETCH_ACCESS_REQUESTS_SUCCESS';
export const SHOWROOM_FETCH_ACCESS_REQUESTS_FAILED =
  'showroomActions/FETCH_ACCESS_REQUESTS_FAILURE';

export const SHOWROOM_REVIEW_ACCESS_REQUEST =
  'showroomActions/REVIEW_ACCESS_REQUEST';
export const SHOWROOM_REVIEW_ACCESS_REQUEST_SUCCESS =
  'showroomActions/REVIEW_ACCESS_REQUEST_SUCCESS';
export const SHOWROOM_REVIEW_ACCESS_REQUEST_FAILED =
  'showroomActions/REVIEW_ACCESS_REQUEST_FAILURE';

// ========================
// Chat Messages
// ========================
export const SHOWROOM_FETCH_CHAT_MESSAGES = 'showroomActions/FETCH_CHAT_MESSAGES';
export const SHOWROOM_FETCH_CHAT_MESSAGES_SUCCESS = 'showroomActions/FETCH_CHAT_MESSAGES_SUCCESS';
export const SHOWROOM_FETCH_CHAT_MESSAGES_FAILED = 'showroomActions/FETCH_CHAT_MESSAGES_FAILURE';

export const SHOWROOM_DELETE_CHAT_MESSAGE = 'showroomActions/DELETE_CHAT_MESSAGE';
export const SHOWROOM_DELETE_CHAT_MESSAGE_SUCCESS = 'showroomActions/DELETE_CHAT_MESSAGE_SUCCESS';
export const SHOWROOM_DELETE_CHAT_MESSAGE_FAILED = 'showroomActions/DELETE_CHAT_MESSAGE_FAILURE';

// ========================
// Eligibility
// ========================
export const SHOWROOM_FETCH_ELIGIBILITY = 'showroomActions/FETCH_ELIGIBILITY';
export const SHOWROOM_FETCH_ELIGIBILITY_SUCCESS = 'showroomActions/FETCH_ELIGIBILITY_SUCCESS';
export const SHOWROOM_FETCH_ELIGIBILITY_FAILED = 'showroomActions/FETCH_ELIGIBILITY_FAILURE';

// ========================
// Pricing Packages (admin)
// ========================
export const SHOWROOM_FETCH_PRICING_PACKAGES = 'showroomActions/FETCH_PRICING_PACKAGES';
export const SHOWROOM_FETCH_PRICING_PACKAGES_SUCCESS = 'showroomActions/FETCH_PRICING_PACKAGES_SUCCESS';
export const SHOWROOM_FETCH_PRICING_PACKAGES_FAILED = 'showroomActions/FETCH_PRICING_PACKAGES_FAILURE';
export const SHOWROOM_UPDATE_PRICING_PACKAGES = 'showroomActions/UPDATE_PRICING_PACKAGES';
export const SHOWROOM_UPDATE_PRICING_PACKAGES_SUCCESS = 'showroomActions/UPDATE_PRICING_PACKAGES_SUCCESS';
export const SHOWROOM_UPDATE_PRICING_PACKAGES_FAILED = 'showroomActions/UPDATE_PRICING_PACKAGES_FAILURE';

// ========================
// Admin actions
// ========================
export const SHOWROOM_PUBLISH_EVENT = 'showroomActions/PUBLISH_EVENT';
export const SHOWROOM_PUBLISH_EVENT_SUCCESS = 'showroomActions/PUBLISH_EVENT_SUCCESS';
export const SHOWROOM_PUBLISH_EVENT_FAILED = 'showroomActions/PUBLISH_EVENT_FAILURE';

export const SHOWROOM_UNPUBLISH_EVENT = 'showroomActions/UNPUBLISH_EVENT';
export const SHOWROOM_UNPUBLISH_EVENT_SUCCESS = 'showroomActions/UNPUBLISH_EVENT_SUCCESS';
export const SHOWROOM_UNPUBLISH_EVENT_FAILED = 'showroomActions/UNPUBLISH_EVENT_FAILURE';

export const SHOWROOM_DELETE_EVENT = 'showroomActions/DELETE_EVENT';
export const SHOWROOM_DELETE_EVENT_SUCCESS = 'showroomActions/DELETE_EVENT_SUCCESS';
export const SHOWROOM_DELETE_EVENT_FAILED = 'showroomActions/DELETE_EVENT_FAILURE';

export const SHOWROOM_ADJUST_SEATS = 'showroomActions/ADJUST_SEATS';
export const SHOWROOM_ADJUST_SEATS_SUCCESS = 'showroomActions/ADJUST_SEATS_SUCCESS';
export const SHOWROOM_ADJUST_SEATS_FAILED = 'showroomActions/ADJUST_SEATS_FAILURE';

export const SHOWROOM_ADMIN_REVIEW_EVENT = 'showroomActions/ADMIN_REVIEW_EVENT';
export const SHOWROOM_ADMIN_REVIEW_EVENT_SUCCESS = 'showroomActions/ADMIN_REVIEW_EVENT_SUCCESS';
export const SHOWROOM_ADMIN_REVIEW_EVENT_FAILED = 'showroomActions/ADMIN_REVIEW_EVENT_FAILURE';

// ========================
// Member Passes (admin batch)
// ========================
export const SHOWROOM_BATCH_FREE_MEMBER_PASS =
  'showroomActions/BATCH_FREE_MEMBER_PASS';
export const SHOWROOM_BATCH_FREE_MEMBER_PASS_SUCCESS =
  'showroomActions/BATCH_FREE_MEMBER_PASS_SUCCESS';
export const SHOWROOM_BATCH_FREE_MEMBER_PASS_FAILED =
  'showroomActions/BATCH_FREE_MEMBER_PASS_FAILURE';

// ========================
// UI State
// ========================
export const SHOWROOM_SET_ACTIVE_TAB = 'showroomActions/SET_ACTIVE_TAB';
export const SHOWROOM_CLEAR_CURRENT_EVENT = 'showroomActions/CLEAR_CURRENT_EVENT';

// ========================
// Action Creators - Events
// ========================
export function fetchShowroomEvents(filters, viewType) {
  return {
    type: SHOWROOM_FETCH_EVENTS,
    filters,
    viewType,
  };
}

export function fetchShowroomEventsSuccess(events, pagination) {
  return {
    type: SHOWROOM_FETCH_EVENTS_SUCCESS,
    events,
    pagination,
  };
}

export function fetchShowroomEventsFailed(err) {
  return {
    type: SHOWROOM_FETCH_EVENTS_FAILED,
    err,
  };
}

export function fetchShowroomEventDetail(eventId) {
  return {
    type: SHOWROOM_FETCH_EVENT_DETAIL,
    eventId,
  };
}

export function fetchShowroomEventDetailSuccess(event) {
  return {
    type: SHOWROOM_FETCH_EVENT_DETAIL_SUCCESS,
    event,
  };
}

export function fetchShowroomEventDetailFailed(err) {
  return {
    type: SHOWROOM_FETCH_EVENT_DETAIL_FAILED,
    err,
  };
}

export function updateShowroomEvent(eventId, details) {
  return {
    type: SHOWROOM_UPDATE_EVENT,
    eventId,
    details,
  };
}

export function updateShowroomEventSuccess(event) {
  return {
    type: SHOWROOM_UPDATE_EVENT_SUCCESS,
    event,
  };
}

export function updateShowroomEventFailed(err) {
  return {
    type: SHOWROOM_UPDATE_EVENT_FAILED,
    err,
  };
}

// ========================
// Action Creators - Host Applications (admin)
// ========================
export function fetchShowroomMembers(filters) {
  return {
    type: SHOWROOM_FETCH_MEMBERS,
    filters,
  };
}

export function fetchShowroomMembersSuccess(members, pagination) {
  return {
    type: SHOWROOM_FETCH_MEMBERS_SUCCESS,
    members,
    pagination,
  };
}

export function fetchShowroomMembersFailed(err) {
  return {
    type: SHOWROOM_FETCH_MEMBERS_FAILED,
    err,
  };
}

// ========================
// Action Creators - Host Approval (admin)
// ========================
export function reviewShowroomHost(companyId, status) {
  return {
    type: SHOWROOM_REVIEW_HOST,
    companyId,
    status,
  };
}

export function reviewShowroomHostSuccess(member) {
  return {
    type: SHOWROOM_REVIEW_HOST_SUCCESS,
    member,
  };
}

export function reviewShowroomHostFailed(err) {
  return {
    type: SHOWROOM_REVIEW_HOST_FAILED,
    err,
  };
}

// ========================
// Action Creators - Viewers
// ========================
export function fetchShowroomViewers(eventId, filters) {
  return {
    type: SHOWROOM_FETCH_VIEWERS,
    eventId,
    filters,
  };
}

export function fetchShowroomViewersSuccess(viewers, pagination) {
  return {
    type: SHOWROOM_FETCH_VIEWERS_SUCCESS,
    viewers,
    pagination,
  };
}

export function fetchShowroomViewersFailed(err) {
  return {
    type: SHOWROOM_FETCH_VIEWERS_FAILED,
    err,
  };
}

// ========================
// Action Creators - Access Requests (host)
// ========================
export function fetchShowroomAccessRequests(eventId) {
  return {
    type: SHOWROOM_FETCH_ACCESS_REQUESTS,
    eventId,
  };
}

export function fetchShowroomAccessRequestsSuccess(accessRequests) {
  return {
    type: SHOWROOM_FETCH_ACCESS_REQUESTS_SUCCESS,
    accessRequests,
  };
}

export function fetchShowroomAccessRequestsFailed(err) {
  return {
    type: SHOWROOM_FETCH_ACCESS_REQUESTS_FAILED,
    err,
  };
}

export function reviewShowroomAccessRequest(
  eventId,
  accessRequestId,
  action,
  reviewNote,
  listViewId
) {
  return {
    type: SHOWROOM_REVIEW_ACCESS_REQUEST,
    eventId,
    accessRequestId,
    action,
    reviewNote,
    listViewId,
  };
}

export function reviewShowroomAccessRequestSuccess(accessRequest) {
  return {
    type: SHOWROOM_REVIEW_ACCESS_REQUEST_SUCCESS,
    accessRequest,
  };
}

export function reviewShowroomAccessRequestFailed(err) {
  return {
    type: SHOWROOM_REVIEW_ACCESS_REQUEST_FAILED,
    err,
  };
}

// ========================
// Action Creators - Chat Messages
// ========================
export function fetchShowroomChatMessages(eventId) {
  return {
    type: SHOWROOM_FETCH_CHAT_MESSAGES,
    eventId,
  };
}

export function fetchShowroomChatMessagesSuccess(messages) {
  return {
    type: SHOWROOM_FETCH_CHAT_MESSAGES_SUCCESS,
    messages,
  };
}

export function fetchShowroomChatMessagesFailed(err) {
  return {
    type: SHOWROOM_FETCH_CHAT_MESSAGES_FAILED,
    err,
  };
}

export function deleteShowroomChatMessage(eventId, messageId) {
  return {
    type: SHOWROOM_DELETE_CHAT_MESSAGE,
    eventId,
    messageId,
  };
}

export function deleteShowroomChatMessageSuccess(messageId) {
  return {
    type: SHOWROOM_DELETE_CHAT_MESSAGE_SUCCESS,
    messageId,
  };
}

export function deleteShowroomChatMessageFailed(err) {
  return {
    type: SHOWROOM_DELETE_CHAT_MESSAGE_FAILED,
    err,
  };
}

// ========================
// Action Creators - Eligibility
// ========================
export function fetchShowroomEligibility() {
  return {
    type: SHOWROOM_FETCH_ELIGIBILITY,
  };
}

export function fetchShowroomEligibilitySuccess(eligibility) {
  return {
    type: SHOWROOM_FETCH_ELIGIBILITY_SUCCESS,
    eligibility,
  };
}

export function fetchShowroomEligibilityFailed(err) {
  return {
    type: SHOWROOM_FETCH_ELIGIBILITY_FAILED,
    err,
  };
}

export function fetchShowroomPricingPackages() {
  return {
    type: SHOWROOM_FETCH_PRICING_PACKAGES,
  };
}

export function fetchShowroomPricingPackagesSuccess(packages) {
  return {
    type: SHOWROOM_FETCH_PRICING_PACKAGES_SUCCESS,
    packages,
  };
}

export function fetchShowroomPricingPackagesFailed(err) {
  return {
    type: SHOWROOM_FETCH_PRICING_PACKAGES_FAILED,
    err,
  };
}

export function updateShowroomPricingPackages(packages) {
  return {
    type: SHOWROOM_UPDATE_PRICING_PACKAGES,
    packages,
  };
}

export function updateShowroomPricingPackagesSuccess(packages) {
  return {
    type: SHOWROOM_UPDATE_PRICING_PACKAGES_SUCCESS,
    packages,
  };
}

export function updateShowroomPricingPackagesFailed(err) {
  return {
    type: SHOWROOM_UPDATE_PRICING_PACKAGES_FAILED,
    err,
  };
}

// ========================
// Action Creators - Admin actions
// ========================
export function publishShowroomEvent(eventId) {
  return {
    type: SHOWROOM_PUBLISH_EVENT,
    eventId,
  };
}

export function publishShowroomEventSuccess(event) {
  return {
    type: SHOWROOM_PUBLISH_EVENT_SUCCESS,
    event,
  };
}

export function publishShowroomEventFailed(err) {
  return {
    type: SHOWROOM_PUBLISH_EVENT_FAILED,
    err,
  };
}

export function unpublishShowroomEvent(eventId) {
  return {
    type: SHOWROOM_UNPUBLISH_EVENT,
    eventId,
  };
}

export function unpublishShowroomEventSuccess(event) {
  return {
    type: SHOWROOM_UNPUBLISH_EVENT_SUCCESS,
    event,
  };
}

export function unpublishShowroomEventFailed(err) {
  return {
    type: SHOWROOM_UNPUBLISH_EVENT_FAILED,
    err,
  };
}

export function deleteShowroomEvent(eventId) {
  return {
    type: SHOWROOM_DELETE_EVENT,
    eventId,
  };
}

export function deleteShowroomEventSuccess(eventId) {
  return {
    type: SHOWROOM_DELETE_EVENT_SUCCESS,
    eventId,
  };
}

export function deleteShowroomEventFailed(err) {
  return {
    type: SHOWROOM_DELETE_EVENT_FAILED,
    err,
  };
}

export function adjustShowroomSeats(eventId, seats) {
  return {
    type: SHOWROOM_ADJUST_SEATS,
    eventId,
    seats,
  };
}

export function adjustShowroomSeatsSuccess(event) {
  return {
    type: SHOWROOM_ADJUST_SEATS_SUCCESS,
    event,
  };
}

export function adjustShowroomSeatsFailed(err) {
  return {
    type: SHOWROOM_ADJUST_SEATS_FAILED,
    err,
  };
}

export function adminReviewShowroomEvent(eventId, action, reviewNote) {
  return {
    type: SHOWROOM_ADMIN_REVIEW_EVENT,
    eventId,
    action,
    reviewNote,
  };
}

export function adminReviewShowroomEventSuccess(event) {
  return {
    type: SHOWROOM_ADMIN_REVIEW_EVENT_SUCCESS,
    event,
  };
}

export function adminReviewShowroomEventFailed(err) {
  return {
    type: SHOWROOM_ADMIN_REVIEW_EVENT_FAILED,
    err,
  };
}

// ========================
// Action Creators - Member Passes (admin batch)
// ========================
export function batchShowroomFreeMemberPass(details) {
  return {
    type: SHOWROOM_BATCH_FREE_MEMBER_PASS,
    details,
  };
}

export function batchShowroomFreeMemberPassSuccess(result) {
  return {
    type: SHOWROOM_BATCH_FREE_MEMBER_PASS_SUCCESS,
    result,
  };
}

export function batchShowroomFreeMemberPassFailed(err) {
  return {
    type: SHOWROOM_BATCH_FREE_MEMBER_PASS_FAILED,
    err,
  };
}

// ========================
// Action Creators - UI State
// ========================
export function showroomSetActiveTab(tab) {
  return {
    type: SHOWROOM_SET_ACTIVE_TAB,
    tab,
  };
}

export function showroomClearCurrentEvent() {
  return {
    type: SHOWROOM_CLEAR_CURRENT_EVENT,
  };
}
